// Lietuvių - lt - 立陶宛语
const lt = {
  home: {
    home: 'Pradžia',
    solutions: 'Sprendimai',
    support: 'Pagalba',
    news: 'Naujienos',
    aboutUs: 'Apie mus',
    contactUs: 'Kontaktai',
    cgm: 'CGM',
    download: 'Atsisiuntimai',
    helpCenter: 'Pagalbos centras',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Visos teisės saugomos.',
    menu: 'Meniu',
    quickLinks: 'Greitos nuorodos',
    contact: 'Kontaktai',
    legal: 'Teisinė informacija',
    termsUse: 'Naudojimo sąlygos',
    privacyPolicy: 'Privatumo politika',
    portal: 'Naudotojo portalas',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'El. paštas',
    subscribe: 'Prenumeruoti',
    signUp: 'Užsiregistruokite gauti naujausias žinias',
    downloadApp: 'Atsisiųsti programėlę',
    blogNews: 'Tinklaraštis ir naujienos',
    latestArticles: 'Naujausi straipsniai',
    viewAllArticles: 'Peržiūrėti visus straipsnius',
    empower: 'Pagerinkite savo sveikatos kelionę su mumis',
    empowerList1Content:
      '„Hippo CGM“ labai palengvino mano sūnaus diabeto valdymą. Galime naudoti HIPPOLINK, kad aiškiai matytume jo gliukozės kiekio tendencijas ir užtikrintai koreguotume jo priežiūrą. Tai suteikia mums ramybę.',
    empowerList1Name:
      'Petra N., Čekija (vaiko, sergančio 1 tipo diabetu, mama)',
    empowerList2Content:
      'Mes rekomenduojame HIPPO CGM pacientams dėl jo stabilaus veikimo ir ilgesnio nešiojimo laiko. Vartotojų atsiliepimai yra puikūs, ypač tų, kurie ieško prieinamesnio varianto.',
    empowerList2Name: 'Dr. Luca B., endokrinologas, Italija',
    empowerList3Content:
      'Neseniai pradėjau naudoti „Hippo CGM“ – jis yra patogus, tikslus, o įspėjimai padėjo man išvengti mažo gliukozės kiekio naktį. Kol kas esu labai patenkintas rezultatais.',
    empowerList3Name: 'Fahad A., Saudo Arabija (2 tipo diabeto pacientas)',
    reliable: 'Jūsų patikimas diabeto valdymo partneris',
    hippoH1: 'HiPPO H1',
    challenges: 'Iššūkiai',
    constant: 'Nuolatinis gliukozės stebėjimas',
    traditional: 'Tradicinis piršto dūris gali būti skausmingas',
    dataOverload: 'Duomenų perteklius',
    managing: 'Gliukozės duomenų valdymas gali būti sudėtingas',
    treatment: 'Gydymo koregavimas',
    accurately: 'Tinkamo gydymo nustatymas yra sudėtingas',
    lifestyle: 'Gyvenimo būdo integracija',
    balancing: 'Subalansuoti mitybą, fizinį aktyvumą ir vaistus',
    hippoCan: 'Hippo biosensoriai siūlo',
    painless: 'Neskausmingas ir diskretiškas stebėjimas',
    ourCgm: 'Mūsų CGM užtikrina nuolatinį matavimą',
    realTime: 'Duomenys ir įžvalgos realiu laiku',
    accessYour: 'Pasiekite duomenis per išmanųjį telefoną',
    personalized: 'Individuali pagalba',
    ourCgmSys:
      'Įspėjimai ir priminimai iš Hippo BioSensors programėlės gali padėti jums laikytis gydymo plano.',
    improved: 'Geresnis sprendimų priėmimas',
    gain: 'Gilesnis supratimas, kaip jūsų organizmas reaguoja į įvykius, suteikia galimybę geriau kompensuoti gliukozės svyravimus. Realaus laiko grįžtamasis ryšys leidžia efektyviau koreguoti savo kasdienę veiklą.',
    // about: 'Apie',
    companyProfile: 'Įmonės profilis',
    banner1Title: 'Sveiki atvykę į Hippo Medical',
    banner1Content: 'CGM inovacijų priešakyje',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Kuriame naujus standartus',
    banner3Content: '24/7 gliukozės apsauga',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'CGM technologijos lyderis',
    // 错误提示
    subscribeSuccess: 'Prenumerata sėkminga', // ai翻译
    subscribeFailed: 'Prenumerata nepavyko', // ai翻译
    invalidEmail: 'Neteisingas el. pašto adresas', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return lt.home.banner1Title;
    },
    get banner1Content() {
      return lt.home.banner4Content;
    },
    whyChoose: 'Kodėl rinktis HiPPO CGM',
    accurate: 'Tikslumas, kuriuo galite pasitikėti',
    accurateText: 'Trečios kartos fermentų technologija suteikia',
    accurateText1: 'stabilų ir tikslų veikimą',
    easyUse: 'Lengva naudoti',
    easyUseText: '14 dienų nuolatinis stebėjimas',
    realTime: 'Stebėjimas',
    realTimeText: 'Hipo ir hiperglikemijos įspėjimai realiu laiku',
    realTimeText1: 'Duomenų dalijimasis realiu laiku',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    keep: 'Informuoja bet kur ir bet kada',
    withHippo: 'Su HiPPO programėlėmis ir portalu',
    smallSensors: 'Maži jutikliai, patogus nešiojimas',
    agpReport:
      'Profesionali AGP ataskaita leido sveikatos priežiūros specialistams ir vartotojams nedelsiant užfiksuoti pagrindinę informaciją.',
    unlimitedFollow: 'Neribotas stebėjimas',
    iWatchApp: 'Galima iWatch programėlė',
    certified: 'Sertifikuota vaikams',
    loremIp:
      'Sistema yra kliniškai patvirtinta ir oficialiai sertifikuota naudoti vaikams nuo 3 metų amžiaus, užtikrinant jaunesnių pacientų saugumą, tikslumą ir komfortą. Dėl įrodyto jutiklio tikslumo ir švelnių, odai nekenksmingų medžiagų, ji užtikrina patikimą gliukozės stebėjimą vaikams ir paaugliams – padėdama sveikatos priežiūros specialistams užtikrintai teikti duomenimis pagrįstą diabeto priežiūrą.',
  },
  news: {
    date: 'Data',
    recommendedArticles: 'Rekomenduojami straipsniai',
  },
  support: {
    download: 'Atsisiųsti vadovus',
    supportDown: 'Palaikymas/Atsisiuntimai',
  },
  about: {
    welcome: 'Sveiki atvykę į Hippo Medical',
    covered: 'Aptarnaujamos šalys',
    patents: 'Patentai',
    features: 'Funkcijos3',
    ring: 'Žiedas',
    apparently:
      'Paslaptingas žiedas, galintis stebėti tokius parametrus kaip deguonies kiekis kraujyje, širdies ritmas ir miegas. Dar svarbiau, jis turi algoritminį ryšį su mūsų CGM. Pasirodys 2026 m. Sekite naujienas!',
    cgmSky:
      'Profesionalus CGM, sukurtas atsižvelgiant tiek į paciento naudojimo, tiek į gydytojo klinikinius poreikius. Jis pasižymi dideliu tikslumu, patogia programinės įrangos sąveika ir veikia „Hippo Medical“ algoritmų pagrindu. Pasirodys 2025 m. birželio mėn.!',
    smartWatch: 'Išmanusis laikrodis',
    byTheSame:
      'Dėvimas dinaminio kraujospūdžio stebėjimo prietaisas, galintis nuolat sekti sistolinį kraujospūdį, diastolinį kraujospūdį, vidutinį arterinį kraujospūdį ir dar daugiau, turintis „Hippo Medical“ sukurtą algoritmą. Pasirodys 2026 m. Sekite naujienas!',
    explore: 'Tyrinėti',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'SINGAPŪRAS (409051)',
    zipCode: 'Pašto kodas',
    emailCode: '409051',
    email: 'El. paštas',
    emailText: 'info@hippodiabetes.com',
    name: 'Vardas',
    company: 'Įmonė',
    message: 'Žinutė',
    phone: 'Telefonas',
    submit: 'Pateikti',
    commingSoon: 'Netrukus',
    cpInfo1:
      'Hippo Medical" yra pasaulinė medicinos technologijų įmonė, kurios būstinė įsikūrusi Singapūre. Ji pasišventusi sukelti lėtinių ligų valdymo revoliuciją pasitelkiant medicininės paskirties dėvimus biosensorius. Mūsų vizija – užtikrinti nuolatinį stebėjimą ir pažangią duomenų analizę.',
    cpInfo2:
      'Kurdami naujos kartos biosensorius ir pažangiausią duomenų intelekto platformą, siekiame transformuoti diagnostiką ir atverti kelią į proaktyvesnę bei labiau personalizuotą ateitį.',
    submitFailed: 'Pateikimas nepavyko', // ai翻译
    get invalidEmail() {
      return lt.home.invalidEmail;
    },
    fillAllFields: 'Prašome užpildyti šį lauką', // ai翻译
  },
  download: {
    language: 'Kalba',
    product: 'Produktas',
    unit: 'Vienetas',
    fetchFailed: 'Gavimas nepavyko', // ai翻译
  },
  help: {
    search: 'Paieška',
    support: 'Palaikymas/Pagalbos centras/H1 CGM',
    source: 'HiPPO H1 CGM internetiniai ištekliai',
    viewAll: 'Peržiūrėti viską',
    insert: 'Kaip įdėti H1 CGM',
    setUp: 'Kaip nustatyti H1 programėlę',
    faq: 'DUK apie H1 CGM',
    freq: 'Dažniausiai užduodami klausimai',
    noData: 'Turinys nerastas..',
    searchKeys: {
      warmUp: 'Įšilimo fazės klaida',
      waterLeakage: 'Vandens nuotėkis',
      lowGlucose: 'Žemas gliukozės lygis',
      cannotPair: 'Nepavyksta susieti su telefonu',
    },
  },
  faq: {
    faq: 'DUK',
    general: 'Bendri klausimai',
    need: 'Reikia pagalbos?',
    here: 'Čia pateikti dažniausiai užduodami klausimai',
    technical: 'Techniniai klausimai',
  },
  lang: {
    chooseCountry: 'Pasirinkite šalį / regioną',
    northAmerica: 'Šiaurės Amerika', // ai翻译
    southAmerica: 'Pietų Amerika', // ai翻译
    europe: 'Europa', // ai翻译
    africa: 'Afrika', // ai翻译
    asia: 'Azija', // ai翻译
    oceania: 'Okeanija', // ai翻译
    other: 'Kita', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Sudžou, Kinija',
      subName: 'Gamybos vieta',
      hovData:
        'Globali būstinė R&D/duomenų centras/verslas Azijai ir Australijai',
    },
    dubai: {
      name: 'Dubajus',
      subName: 'Regioninis biuras',
      hovData: 'Pietryčių Azijos pardavimų komanda',
    },
    singapore: {
      name: 'Singapūras',
      subName: 'Būstinė',
      hovData: 'Pietryčių Azijos pardavimų komanda',
    },
    sanFrancisco: {
      name: 'San Fransiskas, JAV',
      subName: 'Regioninis biuras',
      hovData: 'Šiaurės Amerikos pardavimų komanda',
    },
    barcelona: {
      name: 'Barselona',
      subName: 'Pardavimų biuras',
      hovData:
        'Globali būstinė R&D/duomenų centras/verslas Azijai ir Australijai',
    },
  },
};
export default lt;
